import { Box, Button, Collapse, Typography } from '@mui/material'
import React, { useState } from 'react'
import Link from '../../components/Link'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import RememberMeIcon from '@mui/icons-material/RememberMe'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import PersonIcon from '@mui/icons-material/Person'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import LockIcon from '@mui/icons-material/Lock'
import { useForm } from 'react-hook-form'
import InputField from '../../components/forms/InputField'
import Select from '../../components/forms/Select'
import { yupResolver } from '@hookform/resolvers/yup'
import { registerValidationSchema } from '../../validations/registerValidation'
import InputPassword from '../../components/forms/InputPassword'
import { useNavigate } from 'react-router-dom'
import { BaseService } from '../../services/BaseService'
import { CustomError } from '../../utils/error/customeError'
// import { position } from '../../constants/position'
import Modal from '../../components/Modal'
import RegisterSussess from '../../assets/images/register-susscess.png'
import useTranslate from '../../utils/i18n'
import InputDate from '../../components/forms/InputDate'

const getPosition = async () => {
  const service = new BaseService('/m_posisi')
  const res = await service.getPosition()
  return res.data.data.flat()
}

let position = await getPosition()
position = position.map((p) => ({ label: p, value: p }))

const RegisterPage = () => {
  const { t } = useTranslate()
  const [isError, setIsError] = useState(false)
  const [errMsg, setErrMsg] = useState('Something went wrong!')

  const [open, setOpen] = useState(false)

  const navigate = useNavigate()
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(registerValidationSchema),
  })

  async function handleRegister(form) {
    try {
      // console.clear()
      // console.log(form)
      const service = new BaseService('/m_register_2')
      const res = await service.register(form)
      if (res.data?.status === 'gagal') {
        const err = new CustomError()
        err.error409({
          message: res.data.msg,
        })
      }
      setOpen(true)
    } catch (error) {
      const errMsg = error.response
      if (errMsg) {
        setErrMsg(errMsg.message)
      }
      setIsError(true)
      console.log(error || 'Something went wrong!')
    }
  }

  function handleClose() {
    setOpen(false)
    navigate('/login')
  }

  return (
    <Box mx={'-16px'}>
      <Box
        height={'80px'}
        width={'100%'}
        sx={{
          backgroundColor: ({ palette }) => palette.primary.main,
          borderBottomRightRadius: '60px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Link
          href={'/login'}
          sx={{
            marginLeft: '16px',
          }}
        >
          <ArrowBackIcon
            sx={{
              color: 'white',
            }}
          />
        </Link>
      </Box>
      <Box width={'100%'} mt={3} pb={1}>
        <Collapse in={isError}>
          <Box
            width={'100%'}
            sx={{
              backgroundColor: ({ palette }) => palette.error.light,
              borderRadius: 2,
              p: 3,
              mb: 3,
            }}
          >
            <Typography fontWeight={500} color="white" fontSize={'14px'} textAlign={'center'}>
              {errMsg}
            </Typography>
          </Box>
        </Collapse>
        <Box px={'16px'}>
          <Typography variant="h3" mb={2}>
            {t('register')}
          </Typography>
          <form onSubmit={handleSubmit(handleRegister)}>
            <InputField
              name="nik"
              control={control}
              errors={errors}
              type="text"
              maxLength={16}
              label={t('nik')}
              placeholder={'1234567890000001'}
              startIcon={<RememberMeIcon fontSize="small" />}
              defaultValue={undefined}
            />
            <InputField
              name="nama"
              control={control}
              errors={errors}
              label={t('fullname')}
              placeholder={'Alif Irfan'}
              startIcon={<PersonIcon fontSize="small" />}
            />
            <Select
              name="position"
              control={control}
              errors={errors}
              label={t('position')}
              options={position}
              placeholder={'Posisi'}
            />
            <InputDate
              name="dob"
              control={control}
              errors={errors}
              label={t('dateOfBirth')}
              placeholder={'YYYY-MM-DD'}
            />
            <Select
              name="jk"
              control={control}
              errors={errors}
              label={t('gender')}
              options={[
                { label: 'Laki-laki', value: 'Laki-laki' },
                { label: 'Perempuan', value: 'Perempuan' },
              ]}
              placeholder={t('gender')}
            />
            <InputField
              name="phone"
              control={control}
              errors={errors}
              label={t('phoneNumber')}
              placeholder={'081234567890'}
              startIcon={<LocalPhoneIcon fontSize="small" />}
            />
            <InputField
              name="email"
              control={control}
              errors={errors}
              label={'Email'}
              placeholder={'alif@mail.com'}
              startIcon={<AlternateEmailIcon fontSize="small" />}
            />
            <InputPassword
              name="password"
              control={control}
              errors={errors}
              label={t('password')}
              startIcon={<LockIcon fontSize="small" />}
              placeholder={'********'}
              autoComplate="password"
            />
            <InputPassword
              name="confirmPassword"
              control={control}
              errors={errors}
              label={t('confirmPassword')}
              startIcon={<LockIcon fontSize="small" />}
              placeholder={'********'}
              autoComplate="confirm-password"
            />
            <Button
              variant="contained"
              type="submit"
              fullWidth
              sx={{
                my: 2,
                fontWeight: 700,
                color: 'white',
                minHeight: '48px',
              }}
            >
              {isSubmitting ? 'Loading...' : 'Submit'}
            </Button>
          </form>
        </Box>
        <Typography fontWeight={700} textAlign="center">
          {t('or')}
        </Typography>
        <Typography textAlign="center" mt={1}>
          {t('alreadyAccount')}{' '}
          <Link href={'/login'} sx={{ fontWeight: 700 }}>
            {t('signIn')}
          </Link>
        </Typography>
      </Box>
      <Modal
        open={open}
        handleClose={handleClose}
        title="Register Berhasil"
        buttonVariant="contained"
        buttonTitle="Login"
      >
        <Box>
          <Box display="flex" justifyContent="center" width="100%">
            <Box width="100%" maxWidth={300}>
              <img
                src={RegisterSussess}
                alt="Register Success"
                style={{
                  width: '100%',
                  height: 300,
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Box>
          <Typography fontWeight={700}>Berhasil melakukan register</Typography> <br />
          <Typography>
            Menunggu admin untuk memverifikasi atau hubungi admin untuk verifikasi akun
          </Typography>
        </Box>
      </Modal>
    </Box>
  )
}

export default RegisterPage
